import React, { useState, useEffect, useContext } from "react";
import PreviousWorkSection from "./PreviousWorkSection";
import AnalysisSection from "./AnalysisSection";
import ResultsSection from "./ResultsSection";
import RevisionSection from "./RevisionSection";
import FinalResultsSection from "./FinalResultsSection";
import { logout } from "../utils/firebase";
import "./ResumeRevisor.css";
import axios from "axios";
import { db } from "../utils/firebase";
import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  getDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import DocumentModal from "./DocumentModal";
import VoiceBotIframe from "./VoiceBotiFrame";
import JobSearch from "./JobSearch";
import Papa from "papaparse";
import Spinner from "./Spinner";
import { useAuth } from "./AuthContext";
import { TokenContext } from "./tokenContext"; // import TokenContext
import GlobalNavDrawer from "../components/GlobalNavDrawer";
import VisemeProvider from "./VisemeProvider";
import { extractScoreAfterLabel } from "./resumeFitScore";

function Dashboard() {
  const [showRevisionSection, setShowRevisionSection] = useState(false);
  const [resumeKeywords, setResumeKeywords] = useState([]);
  const [jobDescriptionKeywords, setJobDescriptionKeywords] = useState([]);
  const [atsScore, setAtsScore] = useState(0);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [analysisCompleted, setAnalysisCompleted] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [showFinalResults, setShowFinalResults] = useState(false);
  const [missingKeywords, setMissingKeywords] = useState([]);
  const [assessment, setAssessment] = useState("");
  const [employabilityScore, setEmployabilityScore] = useState(0);
  const [bestPossibleJob, setBestPossibleJob] = useState("");
  const [resumeText, setResumeText] = useState("");
  const [jobDescriptionText, setJobDescriptionText] = useState("");
  const [isRevising, setIsRevising] = useState(false);
  const [revisionCompleted, setRevisionCompleted] = useState(false);
  const [finalResume, setFinalResume] = useState("");
  const [coverLetter, setCoverLetter] = useState("");
  const [newEmployabilityScore, setNewEmployabilityScore] = useState(0);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [deletionCount, setDeletionCount] = useState(0);
  const [documents, setDocuments] = useState([]);
  const [overwriteCount, setoverwriteCount] = useState(0);
  const [saveCount, setSaveCount] = useState(0);
  const [showVoiceBot, setShowVoiceBot] = useState(false);
  const [ReplacementJobDescription, setReplacementJobDescription] =
    useState("");
  const [showPreviousWork, setShowPreviousWork] = useState(false);
  let voiceBotText = "You're at the right place for resume help.";
  let AudioFile = 0;
  let sentences = [];
  const { balance, setBalance } = useContext(TokenContext);
  const { userRole } = useAuth();

  useEffect(() => {
    if (deletionCount > 0 || overwriteCount > 0 || saveCount > 0) {
      fetchUserData();
    }
  }, [deletionCount, overwriteCount, saveCount]);

  const parseCSV = () => {
    return new Promise((resolve, reject) => {
      Papa.parse("/data/AudioFiles.csv", {
        download: true,
        header: false,
        complete: (results) => {
          const arrayOfSentences = results.data
            .map((row) => row[0])
            .filter((sentence) => sentence.trim() !== "");
          resolve(arrayOfSentences);
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  };

  useEffect(() => {
    console.log("Fetching token count from Firebase.");
    let isMounted = true;
    const fetchTokens = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
        if (user) {
          const userRef = doc(db, "users", user.uid);
          try {
            const userDoc = await getDoc(userRef);
            if (userDoc.exists() && isMounted) {
              setBalance(userDoc.data().tokens || 0);
            }
          } catch (error) {
            console.error("Error fetching token count: ", error);
          }
        }
    };
      
    fetchTokens();
      return () => {
        isMounted = false;
      };
  }, [setBalance]);


  async function debitTokens(amount, reason, metadata = {}) {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return false;
    const idToken = await user.getIdToken();
    const r = await fetch('https://fluency.ispeakwell.ca/api/tokens/debit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
      body: JSON.stringify({ amount, reason, metadata })
    });
    const j = await r.json();
    if (!r.ok) { console.error(j); return false; }
    // Optionally update local UI balance
    if (typeof setBalance === 'function') setBalance(j.balance);
    return true;
  }

  async function init() {
    try {
      sentences = await parseCSV();
      // At this point, sentences is populated
    } catch (error) {
      console.error("Error parsing CSV: ", error);
    }
  }

  init();
  const updateReplacementJobDescription = (
    companyName,
    location,
    via,
    description
  ) => {
    const newJobDetails = `Company Name: ${companyName}\nLocation: ${location}\nVia: ${via}\nDescription: ${description}`;
    setReplacementJobDescription(newJobDetails);
  };
  
  const fetchUserData = async () => {
    const auth = getAuth();
    if (auth.currentUser) {
      try {
        const q = query(
          collection(db, "users", auth.currentUser.uid, "documents")
        );
        const querySnapshot = await getDocs(q);
        const updatedDocuments = [];
        querySnapshot.forEach((doc) => {
          updatedDocuments.push({ id: doc.id, ...doc.data() });
        });
        setDocuments(updatedDocuments);
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    }
  };

  const handleAnalysis = async (resumeText, jobDescriptionText) => {
    if (
      window.confirm(
        "This action will require 1 Token.  Do not leave this page during the process."
      )
    ) {
      if(balance >= 1){
        setIsAnalyzing(true);
        const resumeData = { resumeText, jobDescriptionText };
        await handleSubmit(resumeData);
      }else{
        setIsAnalyzing(false);
        alert("You have no tokens.  Purchase some more tokens to continue.");
        return;
      }
    } else {
      return;
    }
  };

  const handleRevisionsSubmission = async (
    resume,
    jobDescription,
    revisions
  ) => {
    setIsRevising(true);
    try {
      const response = await axios.post("/api/submit-revision", {
        resume,
        jobDescription,
        revisions,
      });
      if (response.data && response.data.message) {
        const parsedRevisionData = parseOpenAIResponse(response.data.message);
        console.log("Parsed Revision Data: ", parsedRevisionData);
        setFinalResume(parsedRevisionData.finalResume);
        setCoverLetter(parsedRevisionData.coverLetter);
        setNewEmployabilityScore(parsedRevisionData.newEmployabilityScore);
      }
      setRevisionCompleted(true);
    } catch (error) {
      console.error(error);
      // Handle error (consider updating state to show error in UI)
    } finally {
      setIsRevising(false);
    }
    setShowResults(true); // Hide initial results if showing final results
    setShowRevisionSection(true);
    setShowFinalResults(true);
  };

  const handleSubmit = async (resumeData) => {
    try {
      const response = await axios.post("/api/analyze-resume", resumeData);
      if (response.status === 200) {
        const message = response.data.message;
        const parsedData = parsePlainTextResponse(message);
        setResumeKeywords(parsedData.resumeKeywords);
        setJobDescriptionKeywords(parsedData.jobDescriptionKeywords);
        setAtsScore(parsedData.atsScore);
        setMissingKeywords(parsedData.missingKeywords);
        setAssessment(parsedData.assessment);
        setEmployabilityScore(parsedData.atsScore);
        setBestPossibleJob(parsedData.bestPossibleJob);
        setShowResults(true);
      } else {
        // Handle non-200 status
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsAnalyzing(false);
      setAnalysisCompleted(true);
    }
    setShowRevisionSection(false);
  };

  const [selectedResumeContent, setSelectedResumeContent] = useState("");
  const [selectedCoverLetterContent, setSelectedCoverLetterContent] =
    useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDivClick = (resumeContent, coverLetterContent, documentId) => {
    setSelectedResumeContent(resumeContent);
    setSelectedCoverLetterContent(coverLetterContent);
    setSelectedDocumentId(documentId); // Update the selected document ID
    setIsModalOpen(true);
  };

  const handleRework = () => {
    setResumeText(selectedResumeContent); // Update the resume text for the analysis section
    setIsModalOpen(false); // Close the modal
  };

  function parsePlainTextResponse(text) {
    // Split the entire message by new lines
    text = text.replace(/`/g, "");
    const lines = text.split("\n");

    // Find the indices for each section
    const resumeKeywordsIndex = lines.findIndex((line) =>
      line.includes("Resume Keywords:")
    );
    const jobDescriptionKeywordsIndex = lines.findIndex((line) =>
      line.includes("Job Description Keywords:")
    );
    const missingKeywordsIndex = lines.findIndex((line) =>
      line.includes("Missing Keywords:")
    );
    const assessmentIndex = lines.findIndex((line) =>
      line.includes("Assessment:")
    );
    const employabilityScoreIndex = lines.findIndex((line) =>
      line.includes("Employability Score:")
    );
    const bestPossibleJobIndex = lines.findIndex((line) =>
      line.includes("Best Possible Job:")
    );

    // Filter lines for resume keywords
    const resumeKeywords = lines
      .slice(resumeKeywordsIndex + 1, jobDescriptionKeywordsIndex)
      .filter((line) => line.startsWith("- "))
      .map((keyword) => keyword.substring(2).trim());

    // Filter lines for job description keywords
    const jobDescriptionKeywords = lines
      .slice(jobDescriptionKeywordsIndex + 1, missingKeywordsIndex)
      .filter((line) => line.startsWith("- "))
      .map((keyword) => keyword.substring(2).trim());

    // Extract the assessment text
    const assessment = lines
      .slice(assessmentIndex + 1, employabilityScoreIndex)
      .join(" ")
      .trim();

    // Extract missing keywords
    const missingKeywords = lines
      .slice(missingKeywordsIndex + 1, assessmentIndex)
      .filter((line) => line.startsWith("- "))
      .map((keyword) => keyword.substring(2).trim());

    // The score is often on the line after the label, as in "65/100".
    const parsedAtsScore = extractScoreAfterLabel(lines, employabilityScoreIndex);
    const atsScore = parsedAtsScore == null ? 0 : parsedAtsScore;

    // Extract the best possible job text
    const bestPossibleJob = lines
      .slice(bestPossibleJobIndex + 1)
      .join(" ")
      .trim();

    // Return the parsed data
    return {
      resumeKeywords,
      jobDescriptionKeywords,
      missingKeywords,
      assessment,
      atsScore,
      bestPossibleJob,
    };
  }

  function parseOpenAIResponse(responseText) {
    responseText = responseText.replace(/`/g, "");
    // Split the entire message by new lines
    const lines = responseText.split("\n");

    // Find the indices for each section
    const finalResumeIndex = lines.findIndex((line) =>
      line.includes("Final Resume:")
    );
    const eScoreIndex = lines.findIndex((line) => line.includes("EScore:"));
    const coverLetterIndex = lines.findIndex((line) =>
      line.includes("Cover Letter:")
    );

    let finalResume = "";
    let newEmployabilityScore = 0;
    let coverLetter = "";

    if (finalResumeIndex !== -1 && eScoreIndex !== -1) {
      finalResume = lines
        .slice(finalResumeIndex + 1, eScoreIndex)
        .join("\n")
        .trim();
    }

    if (eScoreIndex !== -1) {
      const parsedRevisionScore = extractScoreAfterLabel(lines, eScoreIndex);
      if (parsedRevisionScore == null) {
        console.error("EScore parsing failed or not found");
        newEmployabilityScore = "N/A";
      } else {
        newEmployabilityScore = parsedRevisionScore;
      }
    } else {
      newEmployabilityScore = "N/A";
    }

    if (coverLetterIndex !== -1) {
      coverLetter = lines
        .slice(coverLetterIndex + 1)
        .join("\n")
        .trim();
    }
      debitTokens(1);

    return {
      finalResume,
      newEmployabilityScore,
      coverLetter,
    };
  }

  const handleSaveToFirestore = async (
    title,
    finalResume,
    coverLetter,
    newEmployabilityScore
  ) => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      try {
        const q = query(
          collection(db, "users", user.uid, "documents"),
          where("title", "==", title)
        );
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          // A document with the same title exists
          const existingDoc = querySnapshot.docs[0];
          await updateDoc(existingDoc.ref, {
            title,
            finalResume,
            coverLetter,
            newEmployabilityScore,
            createdAt: serverTimestamp(),
          });

          console.log("Document overwritten with ID: ", existingDoc.id);
          setoverwriteCount(overwriteCount + 1);
          window.scrollTo(0, 0);
        } else {
          // Save the new document (no existing document found)
          console.log(
            "newEmployabilityScore before addDoc:",
            newEmployabilityScore
          );
          if (newEmployabilityScore === undefined) {
            console.error("newEmployabilityScore is undefined, aborting save");
            return;
          }

          const docRef = await addDoc(
            collection(db, "users", user.uid, "documents"),
            {
              title,
              finalResume,
              coverLetter,
              newEmployabilityScore,
              createdAt: serverTimestamp(),
            }
          );
          console.log("New document written with ID: ", docRef.id);
          setSaveCount(saveCount + 1);
          window.scrollTo(0, 0);
        }
      } catch (error) {
        console.error("Error saving document: ", error);
      }
    } else {
      console.log("No user logged in");
    }
  };

  const handleDeleteDocument = async (documentId) => {
    console.log("Deleting document with ID:", documentId);
    const auth = getAuth();
    try {
      await deleteDoc(
        doc(db, "users", auth.currentUser.uid, "documents", documentId)
      );
      setIsModalOpen(false);
      setDeletionCount(deletionCount + 1);
    } catch (error) {
      console.error("Error deleting document: ", error);
      alert(`Error deleting document: ${error.message}`);
    }
  };

  const handleButtonClick = () => {
    setShowVoiceBot(true);
  };

  function handleVBLastButtonClick(filename) {
    AudioFile--;
    if (AudioFile < 0) {
      AudioFile = 0;
    }
    updateVoiceBotText(sentences[AudioFile]);
    var iframeWindow = document.getElementById("theBot").contentWindow;
    iframeWindow.postMessage(AudioFile, "*"); //"https://voicebot.ispeakwell.ca/"
  }

  function handleVBNextButtonClick() {
    AudioFile++;
    if (AudioFile > 26) {
      AudioFile = 26;
    }
    updateVoiceBotText(sentences[AudioFile]);
    var iframeWindow = document.getElementById("theBot").contentWindow;
    iframeWindow.postMessage(AudioFile, "*"); //"https://voicebot.ispeakwell.ca/"
  }

  function updateVoiceBotText(text) {
    const textElement = document.getElementById("voiceBotTextElement");
    if (textElement) {
      textElement.textContent = text;
    }
  }

    const showResumes = () => {
    setShowPreviousWork(true);
  };

  const hideResumes = () => {
    setShowPreviousWork(false);
  };

  return (
    <VisemeProvider>
      <div className="RR-dashboard">
        <header>
          <h1 className="RR-Main-Header-Resume">The iSpeakWell Project</h1>
          <h2 className="RR-Main-Header">Advanced Resume Revisor</h2>
          <h2 className="RR-Main-Header">& Cover Letter Writer</h2>
        </header>
        {showPreviousWork ? (
          <div className="RR-previous-work-section">
            <PreviousWorkSection
              documents={documents}
              setDocuments={setDocuments}
              onDocumentClick={handleDivClick}
              onDeleteDocument={handleDeleteDocument}
            />
            <div className="RR-HideButton">
              {documents.length === 0 ? (
                <button onClick={hideResumes}>Hide</button>
              ) : (
                <div className="RR-HideButton">
                  <h4 className="RR-instruct1">Click a document to view</h4>
                  <button onClick={hideResumes}>Hide</button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <button onClick={showResumes}>Show Saved Resumes</button>
        )}
        {userRole === "admin" && (
          <div className="RR-jobOps">
            <h3 className="RR-Main-Header">Search Job Opportunities</h3>
            <JobSearch
              onUpdateReplacementJobDescription={updateReplacementJobDescription}
            />
          </div>
        )}
        <div className="RR-analysis-section">
          {!isAnalyzing &&
            !showResults &&
            (showVoiceBot ? (
              <div className="RR-VoiceBot-container">
                <div className="RR-VOICEBOT">
                  <VisemeProvider>
                    <VoiceBotIframe />
                  </VisemeProvider>
                </div>
                <div className="RR-VBButtons">
                  <button onClick={handleVBLastButtonClick}>Last</button>
                  <button onClick={handleVBNextButtonClick}>Next</button>
                </div>
              </div>
            ) : (
              <button onClick={handleButtonClick}>Activate Resume Coach</button>
            ))}
          <div className="RR-VoiceBotSays">
            {!isAnalyzing && !showResults && showVoiceBot && (
              <h5 id="voiceBotTextElement" className="RR-VoiceBotTextDB">
                {voiceBotText}
              </h5>
            )}
          </div>
        </div>
        <div className="RR-analysis-section">
          <AnalysisSection
            onSubmit={handleAnalysis}
            isAnalyzing={isAnalyzing}
            analysisCompleted={analysisCompleted}
            resumeText={resumeText}
            setResumeText={setResumeText}
            jobDescriptionText={jobDescriptionText + ReplacementJobDescription}
            setJobDescriptionText={setJobDescriptionText}
          />
        </div>

        {isAnalyzing && (
          <div style={{ textAlign: "center" }}>
            <Spinner />
          </div>
        )}

        {!isAnalyzing && showResults && (
          <ResultsSection
            resumeKeywords={resumeKeywords}
            jobDescriptionKeywords={jobDescriptionKeywords}
            atsScore={atsScore}
          />
        )}

        {!isAnalyzing &&
          (showResults || showRevisionSection) &&
          !showFinalResults &&
          (showVoiceBot ? (
            <div className="RR-VoiceBot-container">
              <div className="RR-VOICEBOT">
                <VisemeProvider>
                  <VoiceBotIframe />
                </VisemeProvider>
              </div>
              <div className="RR-VBButtons">
                <button onClick={handleVBLastButtonClick}>Last</button>
                <button onClick={handleVBNextButtonClick}>Next</button>
              </div>
            </div>
          ) : (
            <button onClick={handleButtonClick}>Activate Resume Coach</button>
          ))}
        <div className="RR-VoiceBotSays">
          {!isAnalyzing &&
            (showResults || showRevisionSection) &&
            !showFinalResults &&
            showVoiceBot && (
              <h5 id="voiceBotTextElement" className="RR-VoiceBotTextDB">
                {voiceBotText}
              </h5>
            )}
        </div>
        {!isAnalyzing && (showResults || showRevisionSection) && (
          <div className="RR-analysis-section">
            <RevisionSection
              missingKeywords={missingKeywords}
              assessment={assessment}
              employabilityScore={employabilityScore}
              bestPossibleJob={bestPossibleJob}
              onSubmitRevisions={handleRevisionsSubmission}
              originalResume={resumeText}
              originalJobDescription={jobDescriptionText}
              isRevising={isRevising}
              revisionCompleted={revisionCompleted}
            />
          </div>
        )}
        <div className="RR-VoiceBotSays">
          {!isAnalyzing &&
            showFinalResults &&
            (showVoiceBot ? (
              <div className="RR-VoiceBot-container">
                <div className="RR-VOICEBOT">
                  <VisemeProvider>
                    <VoiceBotIframe />
                  </VisemeProvider>
                </div>
                <div className="VBButtons">
                  <button onClick={handleVBLastButtonClick}>Last</button>
                  <button onClick={handleVBNextButtonClick}>Next</button>
                </div>
              </div>
            ) : (
              <button onClick={handleButtonClick}>Activate Resume Coach</button>
            ))}
          <div className="RR-VoiceBotSays">
            {!isAnalyzing && showFinalResults && showVoiceBot && (
              <h5 id="voiceBotTextElement" className="RR-VoiceBotTextDB">
                {voiceBotText}
              </h5>
            )}
          </div>
        </div>
        {!isAnalyzing && showFinalResults && (
          <div className="RR-finalResults-section">
            <FinalResultsSection
              finalResume={finalResume}
              coverLetter={coverLetter}
              newEmployabilityScore={newEmployabilityScore}
              onSave={handleSaveToFirestore}
            />
          </div>
        )}

        <GlobalNavDrawer
          hideCurrent
          links={[
            { to: "/purchase", label: `Tokens: ${balance}`},
            { to: "/voicebot", label: "iSpeakWell" },
            { to: "/conversationpractice", label: "Convos" },
            { to: "/interview-practice", label: "Interviews" },
            { to: "/termsofservice", label: "Terms" },
            { to: "/privacypolicy", label: "Privacy" },
            { to: "/admin", label: "Admin" },
            { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
          ]}
        />

        {isModalOpen && (
          <DocumentModal
            coverLetter={selectedCoverLetterContent}
            resume={selectedResumeContent}
            onClose={() => setIsModalOpen(false)}
            onRework={handleRework}
            onDelete={() => handleDeleteDocument(selectedDocumentId)}
          />
        )}
      </div>
    </VisemeProvider>
  );
}

export default Dashboard;
